import { useState, useEffect } from "react";
import schoolImg from "../../../Assets/School/schoolImg.svg";
import schoolIocn from "../../../Assets/School/schoolIocn.svg";
import navigation_arrows from "../../../Assets/home/nav_arrow.svg";
import back_img from "../../../Assets/School/backImg.svg";
import AliceCarousel from "react-alice-carousel";
import { useLocation, useNavigate } from "react-router-dom";
import "./SchoolDetaileView.scss";
import shareIcon from "../../../Assets/School/shareIcon.svg";
import LikeIcon from "../../../Assets/School/schoolLikeIcon.svg";
import comments from "../../../Assets/School/commentIcon.svg";
import CalenderIcon from "../../../Assets/School/CalendarIcon.svg";
import viewOnMap from "../../../Assets/School/ViewOnMap.svg";
import card_bg from "../../../Assets/Tutor/card_bg.png";
import curriculum from "../../../Assets/School/Curiculam.svg";
import DSIBrating from "../../../Assets/School/DSIBrating.svg";
import FoundYear from "../../../Assets/School/FoundYear.svg";
import Ranking from "../../../Assets/School/Ranking.svg";
import { Container, Tooltip, CircularProgress } from "@mui/material";
import React from "react";
import {
  API_END_POINTS,
  AUTHENTICATION,
  GLOBAL_CONSTANTS,
  ROUTES,
  getGoogleMapLink,
} from "../../../Constants/Constants";
import { useTheme } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { axiosInstance } from "../../../Utilities/Interceptor/Interceptor";
import toast from "react-hot-toast";
import SchoolFill from "../../../Assets/HeartFill/SchoolFill.svg";
import {
  GetSessionStorageData,
  decrypPassData,
  encryptPassData,
  nullUndefinedEmptyCheck,
} from "../../../Utilities/Helpers/Helper";
import { setChildLoginRestriction, setErrorMessage, setErrorNotification, setLoader, setLoginSignUpOpen } from "../../../Redux/Reducer/Reducer";
import emailIcon from "../../../Assets/School/emailIcon.svg";
import websiteIcon from "../../../Assets/School/websiteIcon.svg";
import callIcon from "../../../Assets/School/callIcon.svg";
import PersonIcon from "../../../Assets/School/PersonIcon.svg";
import location_icon from "../../../Assets/Header/header_location_icon.svg";
import down_arrow from "../../../Assets/School/school_down_arrow.svg";
import up_arrow from "../../../Assets/School/school_up_arrow.svg";
import filp_arrow from "../../../Assets/School/school_filp_arrow.png";
import pdf from "../../../Assets/School/school__pdf.svg";
import WebShareComponent from "../../../Components/WebShare/WebShare";
import { store } from "../../../Redux/Store/Store";
import { useDispatch, useSelector } from "react-redux";
import ViewMoreLess from "../../../Components/ViewMoreCommon";
import { useTranslation } from "react-i18next";

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const SchoolDetaileView = () => {
  const { t } = useTranslation();
  const route = useLocation();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const qureyId: any = searchParams.get("id");
  const [mousePosition, setMousePosition] = useState({ x: null, y: null });
  const [sericeCardsTemplate, setServiceCardsTemplate] = useState<any>([]);
  const [toturDetailes, setToturDetailes] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasValidData, setHasValidData] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const dispatch = useDispatch();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [Detailesvalue, setDetailesValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleChangeDetailes = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setDetailesValue(newValue);
  };

  const handleChangeIndex = (index: number) => {
    setValue(index);
  };

  const getOneList = () => {
    setIsLoading(true);
    setHasValidData(false);
    var id: any = "?id=" + decrypPassData(qureyId);
    axiosInstance
      .get(`${API_END_POINTS.SCHOOLLIST + id}`)
      .then((Response: any) => {
        if (Response?.data?.status) {
          const data = Response?.data?.result?.data;
          setToturDetailes(data);
          setServiceCardsTemplate(getServiceCards(data));
          setHasValidData(!!data && data.school_name);
        }
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  const getServiceCards = (details: any) => {
    const validImages = (details?.images || []).filter((item: string) =>
      nullUndefinedEmptyCheck(item) && item.trim() !== "" && item.startsWith("http")
    );

    if (validImages.length === 0) {
      return [0, 1, 2].map((i) => (
        <div className="service_card" key={i}>
          <div className="service_card_container">
            <img
              src={card_bg}
              alt="placeholder"
              className="slider-img"
            />
          </div>
        </div>
      ));
    }

    return validImages.map((item: string) => (
      <div className="service_card" key={item}>
        <div className="service_card_container">
          <img
            src={item}
            alt="school"
            onError={(e: any) => { e.target.src = card_bg; }}
            className="slider-img"
            onMouseMove={(event: any) => positionElement(event)}
            onMouseLeave={handleMouseLeave}
          />
        </div>
      </div>
    ));
  };

  const getMainImage = (details: any) => {
    const firstImage = details?.images?.[0];
    return nullUndefinedEmptyCheck(firstImage) && firstImage.startsWith("http") ? firstImage : null;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getOneList();
  }, []);

  const syncActiveIndex = ({ item }: any) => {
    setActiveIndex(item);
  };

  const handleMouseLeave = () => {
    setMousePosition({ x: null, y: null });
  };

  const positionElement = (e: any) => {
    setMousePosition({ x: e.pageX, y: e.pageY });
  };

  const handleChangeFavourites = (val: any, id: any) => {
    const accessToken = GetSessionStorageData(AUTHENTICATION.SHARED.ACCESS_TOKEN);
    if (nullUndefinedEmptyCheck(accessToken)) {
      var payload = {
        service_provider_type: GLOBAL_CONSTANTS.INITIAL_VALUES.FOUR_INT,
        service_provider: id,
        is_favourite: !val,
      };
      axiosInstance
        .post(`${API_END_POINTS.FAVOURITE__ADD}`, payload)
        .then((Response: any) => {
          if (Response?.data?.status) {
            toast.success(Response?.data?.message, {
              position: GLOBAL_CONSTANTS.INITIAL_VALUES.TOAST_POSITION,
            });
            getOneList();
          }
        })
        .catch(() => {});
    } else {
      dispatch(setLoginSignUpOpen(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
    }
  };

  const handleRouteMap = () => {
    var Filter = {
      selectedCheckCourse: [],
      selectedCheckGender: [],
      selectedCheckGrade: [],
      startRating: [],
    };
    navigate(ROUTES.SCHOOL_MAPS_VIEW, {
      state: {
        tutor_list: toturDetailes,
        search_text: null,
        redius: GLOBAL_CONSTANTS.INITIAL_VALUES.FIVE_INT,
        lat: parseFloat(toturDetailes?.latitude),
        lang: parseFloat(toturDetailes?.longitude),
        filter: Filter,
      },
    });
  };

  const handleOpenMap = async (data: any) => {
  const getDestination = { lat: data.latitude, lng: data.longitude };
  const mapsUrl = await getGoogleMapLink(getDestination);
  window.open(mapsUrl, "_blank");
};


  const DownloadPdf = (data: any) => {
    if (nullUndefinedEmptyCheck(data)) {
      store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
      fetch(data, {
        method: "GET",
      })
        .then((resp) => resp.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          const urlParts = data?.split('/');
          const fileName = urlParts[urlParts?.length - 1];
          a.style.display = "none";
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          setTimeout(() => {
            toast.success("Download Pdf Successfully", {
              position: "top-right",
            });
            store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.FALSE));
          }, 500);
        })
        .catch(() => {
          setTimeout(() => {
            store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.FALSE));
          }, 500);
        });
    } else {
      store.dispatch(setErrorNotification(true));
      store.dispatch(setErrorMessage("No data Found"));
    }
  };

  const NavigateCalendar = (url: any, id: any) => {
    if (nullUndefinedEmptyCheck(id)) {
      if (GetSessionStorageData(AUTHENTICATION.SHARED.ACCOUNT_TYPE) === AUTHENTICATION.PROFILE_ACCOUNT_TYPE.PARENT) {
        var payload = {
          school_id: id,
        };
        axiosInstance
          .post(`${API_END_POINTS.SCHOOL_CONTACT_NOTIFICATION}`, payload)
          .then((Response: any) => {
            if (Response?.data?.status) {
              toast.success(Response?.data?.message, {
                position: GLOBAL_CONSTANTS.INITIAL_VALUES.TOAST_POSITION,
              });
            }
          })
          .catch(() => {});
      } else {
        dispatch(setChildLoginRestriction(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
      }
    } else {
      window.open(url, "_blank");
    }
  };

  const handleChatRequest = () => {
    const accessToken = GetSessionStorageData(AUTHENTICATION.SHARED.ACCESS_TOKEN);
    if (nullUndefinedEmptyCheck(accessToken)) {
      if (GetSessionStorageData(AUTHENTICATION.SHARED.ACCOUNT_TYPE) === AUTHENTICATION.PROFILE_ACCOUNT_TYPE.PARENT) {
        axiosInstance
          .get(`${API_END_POINTS.SCHOOL_EXPERT + '?school_id=' + toturDetailes?.id}`)
          .then((Response: any) => {
            if (Response?.data?.status) {
              var status = Response?.data?.result?.data[0];
              if (status?.room_id === 0) {
                let payload = {
                  school_id: toturDetailes?.id,
                };
                axiosInstance
                  .post(`${API_END_POINTS.SCHOOL_EXPERT}`, payload)
                  .then((Response: any) => {
                    if (Response?.data?.status) {
                      var status_new = Response?.data?.result?.data[0];
                      navigate(ROUTES.SCHOOL_CHAT_VIEW, {
                        state: { roomData: status_new, is_notification: false },
                      });
                    }
                  })
                  .catch(() => {});
              } else {
                navigate(ROUTES.SCHOOL_CHAT_VIEW, {
                  state: { roomData: status, is_notification: false },
                });
              }
            }
          })
          .catch(() => {});
      } else {
        dispatch(setChildLoginRestriction(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
      }
    } else {
      dispatch(setLoginSignUpOpen(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
    }
  };

  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });
  const TutorListConatinerLang = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "tutorlist-conatiner-english" : "tutorlist-conatiner-arab";
  const UnversityIconLang = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "unversity-icon-english" : "unversity-icon-arab";
  const school__tap__contant = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "school__tap__contant" : "school__tap__contant_arb";
  const school_back_img = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "back-img" : "back-img_arb";

  if (isLoading || !hasValidData) {
    return (
      <Container component="main" maxWidth="xl" sx={{ mb: 4, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <React.Fragment>
      <Container component="main" maxWidth="xl" sx={{ mb: 4 }}>
        <div className="University__Detaile__view">
          <div className="tittle-div">
            <img
              src={back_img}
              alt="test"
              className={school_back_img}
              onClick={() => navigate(-1)}
            />
            <img src={schoolIocn} alt="" className={`${UnversityIconLang} unversity-icon`} />
            <label className="text-tittle">{t("Schools")}</label>
          </div>
          <div className="row mt-2 w-100">
            <div className={`${TutorListConatinerLang} col-xl-4 col-lg-12 tutorlist-conatiner`}>
              <div className="display-container">
                {getMainImage(toturDetailes) ? (
                  <img
                    src={getMainImage(toturDetailes)}
                    onError={(e: any) => { e.target.src = schoolImg; }}
                    alt="school"
                    className="tutor-image"
                  />
                ) : (
                  <img src={schoolImg} alt="school placeholder" className="tutor-image" />
                )}
                <label className="text14 notranslate" translate="no">
                  {language === "English" ? toturDetailes?.school_name || "" : toturDetailes?.arabic_school_name || toturDetailes?.school_name || ""}
                </label>
                <div className="text10">{toturDetailes?.about_me || ""}</div>
                <div className="View__on__map__container_school">
                  {nullUndefinedEmptyCheck(toturDetailes?.academic_calendar) && (
                    <div
                      className="wapperDiv"
                      onClick={() => NavigateCalendar(toturDetailes?.academic_calendar, null)}
                    >
                      <img src={CalenderIcon} alt="" />
                      <span>{t("Academic Calendar")}</span>
                    </div>
                  )}
                  <div className="wapperDiv" onClick={() => handleOpenMap(toturDetailes)}>
                    <img src={viewOnMap} alt="" />
                    <span>{t("View on Map")}</span>
                  </div>
                </div>
                <div className="iconBtn__wapper__school">
                  <button
                    className="iconBtn"
                    onClick={() => handleChangeFavourites(toturDetailes?.is_favourite, toturDetailes?.user)}
                  >
                    <img
                      src={toturDetailes?.is_favourite ? SchoolFill : LikeIcon}
                      alt=""
                      className="img-size5"
                    />
                    <span>{t("Add favorite")}</span>
                  </button>
                  <WebShareComponent
                    params={ROUTES.SCHOOL_DETAILE_VIEW + "?id=" + encryptPassData(toturDetailes?.id)}
                  >
                    <button className="iconBtn">
                      <img src={shareIcon} alt="" className="img-size5" />
                      <span>{t("Share Profile")}</span>
                    </button>
                  </WebShareComponent>
                </div>
              </div>
            </div>
            <div className={`${TutorListConatinerLang} col-xl-7 col-lg-12 tutorlist-conatiner detailes__scroll__container_university`}>
              {sericeCardsTemplate.length ? (
                <div className="display-container5">
                  <AliceCarousel
                    mouseTracking
                    autoWidth
                    disableButtonsControls
                    items={sericeCardsTemplate}
                    disableDotsControls
                    activeIndex={activeIndex}
                    onSlideChanged={syncActiveIndex}
                  />
                  {mousePosition.x !== null && mousePosition.y !== null && (
                    <div
                      className="custom_cursor"
                      style={{ top: mousePosition.y, left: mousePosition.x }}
                    >
                      <img src={navigation_arrows} alt="Learn and Play" />
                    </div>
                  )}
                </div>
              ) : null}
              <div className="row">
                <div className="col-md-6 icons-gap bottom__contant__wapper__school">
                  <div className="bottom__contant__left">
                    <img src={DSIBrating} alt="" />
                    <div>{t("DSIB Rating")}</div>
                  </div>
                  <div className="bottom__contant__right">{toturDetailes?.dsip_rating || "N/A"}</div>
                </div>
                <div className="col-md-6 icons-gap bottom__contant__wapper__school">
                  <div className="bottom__contant__left">
                    <img src={FoundYear} alt="" />
                    <div>{t("Founded")}</div>
                  </div>
                  <div className="bottom__contant__right">{toturDetailes?.founded_year || "N/A"}</div>
                </div>
                <div className="col-md-6 icons-gap bottom__contant__wapper__school">
                  <div className="bottom__contant__left">
                    <img src={curriculum} alt="" />
                    <div>{t("Curriculum")}</div>
                  </div>
                  <div className="bottom__contant__right">
                    {toturDetailes?.curriculam?.length > 15 ? (
                      <Tooltip title={toturDetailes.curriculam} placement="top-start" componentsProps={{
                        tooltip: { style: { fontSize: '13px' } },
                      }}>
                        <span>{`${toturDetailes.curriculam.slice(0, 15)}...`}</span>
                      </Tooltip>
                    ) : (
                      toturDetailes?.curriculam || "N/A"
                    )}
                  </div>
                </div>
                <div className="col-md-6 icons-gap bottom__contant__wapper__school">
                  <div className="bottom__contant__left">
                    <img src={Ranking} alt="" />
                    <div>{t("Ranking")}</div>
                  </div>
                  <div className="bottom__contant__right">{toturDetailes?.ranking || "N/A"}</div>
                </div>
              </div>
              {toturDetailes?.description && (
                <div className="School_description_contant">
                  <label className="title">{t("Description")}</label>
                  <ViewMoreLess text={toturDetailes?.description} maxLength={100} />
                </div>
              )}
              {(toturDetailes?.application_process?.length > 0 || toturDetailes?.eligibility_criteria?.length > 0) && (
                <div className="school__Taps__container">
                  <Box sx={{ borderBottom: 1, borderColor: "divider", marginTop: "1rem" }}>
                    <Tabs
                      className="School__Taps"
                      value={value}
                      onChange={handleChange}
                      aria-label="basic tabs example"
                      textColor="secondary"
                      indicatorColor="secondary"
                      variant="scrollable"
                    >
                      <Tab label={t("Application Process")} {...a11yProps(0)} />
                      <Tab label={t("Eligibility Criteria")} {...a11yProps(1)} />
                    </Tabs>
                  </Box>
                  <TabPanel value={value} index={0}>
                    <div className={school__tap__contant}>
                      <ul>
                        {toturDetailes?.application_process?.map((data: any) => (
                          <li key={data}>{data}</li>
                        ))}
                      </ul>
                    </div>
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    <div className={school__tap__contant}>
                      <ul>
                        {toturDetailes?.eligibility_criteria?.map((data: any) => (
                          <li key={data}>{data}</li>
                        ))}
                      </ul>
                    </div>
                  </TabPanel>
                </div>
              )}
              <div className="school__Taps__container">
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    className="School__Taps"
                    value={Detailesvalue}
                    onChange={handleChangeDetailes}
                    aria-label="basic tabs example"
                    textColor="secondary"
                    indicatorColor="secondary"
                    variant="scrollable"
                  >
                    <Tab label={t("School Details")} {...a11yProps(0)} />
                    <Tab label={t("Fees Structure")} {...a11yProps(1)} />
                    <Tab label={t("Fees Per Year")} {...a11yProps(2)} />
                  </Tabs>
                </Box>
                <TabPanel value={Detailesvalue} index={0}>
                  <div className="School__personal__detailes__wapper">
                    <div className="detailes__wapper">
                      <div className="left__side">
                        <img src={websiteIcon} alt="" />
                        <span>{t("Website")}</span>
                      </div>
                      <a className="link" href={toturDetailes?.web_link} target="_blank">
                        {toturDetailes?.web_link || "N/A"}
                      </a>
                    </div>
                    <div className="detailes__wapper">
                      <div className="left__side">
                        <img src={emailIcon} alt="" />
                        <span>{t("Email")}</span>
                      </div>
                      <div className="number">{toturDetailes?.email || "N/A"}</div>
                    </div>
                    <div className="detailes__wapper">
                      <div className="left__side">
                        <img src={callIcon} alt="" />
                        <span>{t("Call")}</span>
                      </div>
                      <div className="number">{toturDetailes?.phone_number || "N/A"}</div>
                    </div>
                    <div className="detailes__wapper">
                      <div className="left__side">
                        <img src={location_icon} alt="" />
                        <span>{t("Location")}</span>
                      </div>
                      <div className="text" title={toturDetailes?.address}>{toturDetailes?.address || "N/A"}</div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel value={Detailesvalue} index={1}>
                  <div className="School__fess__structure__wapper">
                    {toturDetailes?.fees_structure?.map((data: any) => (
                      <div className="detailes__wapper" key={Object.keys(data)[0]}>
                        <div className="left__side">
                          <span>{Object.keys(data)[0]}</span>
                        </div>
                        <div className="fees__wapper">
                          <div className="text">{t("AED")}</div>
                          <div className="number">{String(Object.values(data)[0]) || "N/A"}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </TabPanel>
                <TabPanel value={Detailesvalue} index={2}>
                  <div className="School__fess__per_Year__wapper">
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col" className="light_text">{t("Grade\Year")}</th>
                          <th scope="col" className="light_text">{t("Annual Fee")}</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {toturDetailes?.fees_per_year?.map((data: any) => (
                          <tr key={data.grade}>
                            <td className="text">{data?.grade || "N/A"}</td>
                            <td>
                              <div className="fees__wapper">
                                <div className="text">{t("AED")}</div>
                                <div className="number">{data?.fee || "N/A"}</div>
                              </div>
                            </td>
                            {data?.detail && (
                              <td>
                                <img src={pdf} alt="pdf" onClick={() => DownloadPdf(data?.detail)} />
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </TabPanel>
              </div>
              <div className="school_join__now_wapper">
                <button
                  className="join__now_Btn"
                  onClick={() => {
                    const accessToken = GetSessionStorageData(AUTHENTICATION.SHARED.ACCESS_TOKEN);
                    if (nullUndefinedEmptyCheck(accessToken)) {
                      handleChatRequest();
                    } else {
                      dispatch(setLoginSignUpOpen(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
                    }
                  }}
                >
                  {t("Chat with our consultant")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default SchoolDetaileView;